module.exports = __webpack_public_path__ + "static/media/045.ca6508a3.jpg";